import { action } from '@ember/object';
import Component from '@glimmer/component';

import $ from 'jquery';

import didInsert from 'webapp/modifiers/did-insert';
import willDestroy from 'webapp/modifiers/will-destroy';
import ScorecardMetricsRowComponent from 'webapp/components/scorecard/metrics-row';

import type DataSelect from 'webapp/models-custom/data-select';
import type DateRange from 'webapp/models-custom/date-range';
import type DsCompare from 'webapp/models-custom/ds-compare';

interface Args {
	model: DataSelect[];
	submitInProgress: boolean;
	scorecardDateRange: DateRange;
	scorecardCompare: DsCompare;
	onMove: (previousPosition: number, position: number) => void;
	onDelete: (ds: DataSelect) => void;
}

export default class ScorecardMetricsComponent extends Component<Args> {
	el!: JQuery;

	@action
	setupView(node: HTMLElement): void {
		this.el = $(node);
		this.setupSortable();
	}

	@action
	teardownView(): void {
		this.destroySortable();
	}

	private setupSortable(): void {
		this.el.sortable({
			items: '>.row',
			handle: '.hover a.drag-handle',
			axis: 'y',
			containment: 'parent',
			tolerance: 'pointer', // otherwise containment parent cannot handle 1st or last sorts
			placeholder: 'sort-placeholder',
			forcePlaceholderSize: true,
			start: function (_event: JQuery.Event, ui: jQueryUIInstance) {
				ui.helper.addClass('sort-helper active-helper'); //for animation
				ui.helper.data('current-position', ui.helper.index());
			},
			beforeStop: function (_event: JQuery.Event, ui: jQueryUIInstance) {
				ui.helper.removeClass('sort-helper active-helper');
			},
			update: (_event: JQuery.Event, ui: jQueryUIInstance) => {
				const prevIndex = ui.item.data('current-position') as number,
					index = ui.item.index();
				this.args.onMove(prevIndex, index);
			},
		});
	}

	private destroySortable(): void {
		try {
			this.el.sortable('destroy');
		} catch (_e) {
			// skip
		}
	}
	<template>
		<div
			class="row row--scorecard-metrics"
			{{didInsert this.setupView}}
			{{willDestroy this.teardownView}}
		>
			{{#each @model as |item|}}
				<ScorecardMetricsRowComponent
					@model={{item}}
					@submitInProgress={{@submitInProgress}}
					@scorecardDateRange={{@scorecardDateRange}}
					@scorecardCompare={{@scorecardCompare}}
					@onDelete={{@onDelete}}
				/>
			{{/each}}
		</div>
	</template>
}
